<template>
    {{ countDown }}
 </template>
 
 <script>
     export default {
        name: 'Timer',

        emits: ['timerEvent'],

        setup(props, { emit }) {
            
            const handleOnComplete = (isComplete) => {
                emit("timerEvent", isComplete);
            };

            return { handleOnComplete };
        },

         data () {
             return {
                 countDown: 60
             }
         },

         methods: {
             countDownTimer () {
                 if (this.countDown > 0) {
                     setTimeout(() => {
                         this.countDown -= 1
                         this.countDownTimer()
                     }, 1000)
                 } else {
                 this.handleOnComplete(true);
                }
             }
         },
     }
 </script>